// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MessageFilledSvg from "@ant-design/icons-svg/es/asn/MessageFilled";
import AntdIcon from '../components/AntdIcon';

var MessageFilled = function MessageFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MessageFilledSvg
  }));
};

MessageFilled.displayName = 'MessageFilled';
export default React.forwardRef(MessageFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/MessageFilled.js
// module id = 1481
// module chunks = 0